// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, maybe, objectOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isGetCustomObjectsCustomObjectTypesResult = objectOf({
  items: arrayOf(
    objectOf({
      type_name: string,
      co_type_id: number,
      display_name_singular: string,
      display_name_plural: string,
      icon: string,
      description: maybe(string, true),
    })
  ),
});
